import React, {useMemo} from "react";
import {Stack, Card, Text} from "@chakra-ui/react";
import axios from "../axios/axios";
import moment from "moment";
import TaskTable from "../components/TaskTable";
import formatHoursAndMinutes from "../lib/helpers/formatHoursAndMinutes";
import {useTasks} from "../providers/TasksProvider";
import {Header} from "../components/Header";
import {format} from "date-fns";

export default function TasksOldContainer({user}) {
    const {completedTasks, fetchTasks} = useTasks();

    const onDuplicateTask = taskId => {
        axios
            .post("/duplicate_task", {
                task_id: taskId,
            })
            .then(() => {
                fetchTasks();
            })
            .catch(error => console.error("Error duplicating the task:", error));
    };

    const onEditTask = (taskId, timeSpent) => {
        axios
            .put(`/user_task/${taskId}`, {
                time_spent: timeSpent,
            })
            .then(() => {
                fetchTasks();
            })
            .catch(error => console.error("Error editing the task:", error));
    };

    const allPreviousTasksByDate = useMemo(() => {
        const today = format(new Date(), "yyyy-MM-dd");
        // Regroupe les tâches par date
        const groupedTasks = completedTasks.reduce((acc, task) => {
            const taskDate = format(new Date(task.created_at), "yyyy-MM-dd");

            if (taskDate <= today) {
                if (!acc[taskDate]) acc[taskDate] = [];
                acc[taskDate].push(task);
            }

            return acc;
        }, {});

        return Object.entries(groupedTasks);
    }, [completedTasks]);

    return (
        <>
            {allPreviousTasksByDate.length > 0 && (
                <Stack spacing={5} my={5}>
                    <Header as="h2" size="lg">
                        Tâches des jours précédents
                    </Header>

                    {allPreviousTasksByDate.map(([date, tasksForDate]) => {
                        const totalTime = tasksForDate.reduce((sum, task) => sum + parseFloat(task.time_spent), 0) / 60;

                        return (
                            <Card key={date} p={5}>
                                <Header as="h3" size="md">
                                    {moment(date).format("DD/MM/YYYY")}
                                </Header>

                                {totalTime < 7 && (
                                    <Text color="red.500" mt={2}>
                                        ⚠️ Moins de 7h effectuées : {formatHoursAndMinutes(totalTime)}
                                    </Text>
                                )}

                                <TaskTable
                                    userTasks={tasksForDate}
                                    onDuplicateTask={onDuplicateTask}
                                    onEditTask={onEditTask}
                                />
                            </Card>
                        );
                    })}
                </Stack>
            )}
        </>
    );
}
